import React, { ChangeEvent } from 'react';
import '../../App.scss';
import { transliterate } from '../../lib/cyrillicToLatic';

interface ICodeInputProps {
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;
  setErrorText: React.Dispatch<React.SetStateAction<string | null>>;
}

const CodeInput = ({ code, setCode, setErrorText }: ICodeInputProps) => {
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^a-zA-ZА-Яа-я0-9]/g, ''); // Allow only alphanumeric characters
    let formattedValue = rawValue
      .replace(/О/g, 'O') // Replace Cyrillic 'О' with Latin 'O'
      .replace(/Р/g, 'P') // Replace Cyrillic 'Р' with Latin 'P'
      .slice(0, 9); // Limit to 9 characters

    if (/[А-Яа-я]/.test(rawValue)) {
      formattedValue = transliterate(formattedValue);
    }

    const parts = [
      formattedValue.slice(0, 2),
      formattedValue.slice(2, 5),
      formattedValue.slice(5, 8),
    ].filter(Boolean);

    const maskedValue = parts.join('-');

    setCode(maskedValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && code === '') {
      setErrorText(null);
    }
  };

  return (
    <input
      value={code}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      maxLength={10}
      className="input"
      placeholder="XX-XXX-XXX"
    />
  );
};

export default CodeInput;
